export const HKDSE_MATHS_MC_2017 = {
    year: 2017,
    title: "HKDSE 數學科 多項選擇題 2017 (Part 1)",
    totalQuestions: 45,
    timeLimit: 120, // minutes
    questions: [
      {
        id: "2017Q001",
        questionNumber: 1,
        question: "$3m^2 - 5mn + 2n^2 + m - n =$",
        options: [
          { id: "A", text: "$(m-n)(3m-2n+1)$" },
          { id: "B", text: "$(m-n)(3m+2n+1)$" },
          { id: "C", text: "$(m+n)(3m-2n-1)$" },
          { id: "D", text: "$(m+n)(3m+2n-1)$" }
        ],
        correctAnswer: "A",
        solution: "$3m^2 - 5mn + 2n^2 + m - n = (3m^2 - 5mn + 2n^2) + (m - n)$\\n$= (3m-2n)(m-n) + (m-n) = (m-n)(3m-2n+1)$",
        topic: "因式分解",
        difficulty: "中等"
      },
      {
        id: "2017Q002",
        questionNumber: 2,
        question: "$\\left(\\frac{1}{9^{555}}\\right) 3^{444} =$",
        options: [
          { id: "A", text: "$0$" },
          { id: "B", text: "$\\frac{1}{3^{111}}$" },
          { id: "C", text: "$\\frac{1}{3^{222}}$" },
          { id: "D", text: "$\\frac{1}{3^{666}}$" }
        ],
        correctAnswer: "B",
        solution: "$\\left(\\frac{1}{9^{555}}\\right) 3^{444} = \\frac{3^{444}}{9^{555}} = \\frac{3^{444}}{(3^2)^{555}} = \\frac{3^{444}}{3^{1110}} = \\frac{1}{3^{666}}$",
        topic: "指數",
        difficulty: "中等"
      },
      {
        id: "2017Q003",
        questionNumber: 3,
        question: "若 $\\frac{a+4b}{2a} = 2 + \\frac{b}{a}$，則 $a =$",
        options: [
          { id: "A", text: "$\\frac{2b}{3}$" },
          { id: "B", text: "$\\frac{3b}{2}$" },
          { id: "C", text: "$\\frac{5b}{6}$" },
          { id: "D", text: "$\\frac{6b}{5}$" }
        ],
        correctAnswer: "A",
        solution: "$\\frac{a+4b}{2a} = 2 + \\frac{b}{a}$\\n$\\frac{a+4b}{2a} = \\frac{2a+b}{a}$\\n$a+4b = 2(2a+b)$\\n$a+4b = 4a+2b$\\n$2b = 3a$\\n$a = \\frac{2b}{3}$",
        topic: "分式方程",
        difficulty: "中等"
      },
      {
        id: "2017Q004",
        questionNumber: 4,
        question: "$\\frac{1}{\\pi^4} =$",
        options: [
          { id: "A", text: "$0.0102$ (準確至三位有效數字)" },
          { id: "B", text: "$0.01025$ (準確至四位有效數字)" },
          { id: "C", text: "$0.01026$ (準確至五位小數)" },
          { id: "D", text: "$0.010266$ (準確至六位小數)" }
        ],
        correctAnswer: "A",
        solution: "$\\frac{1}{\\pi^4} \\approx 0.0102$ (準確至三位有效數字)",
        topic: "近似值",
        difficulty: "基礎"
      },
      {
        id: "2017Q005",
        questionNumber: 5,
        question: "$6 - x < 2x - 3$ 或 $7 - 3x > 1$ 的解為",
        options: [
          { id: "A", text: "$x < 2$" },
          { id: "B", text: "$x > 3$" },
          { id: "C", text: "$2 < x < 3$" },
          { id: "D", text: "$x < 2$ 或 $x > 3$" }
        ],
        correctAnswer: "D",
        solution: "$6 - x < 2x - 3$ 得 $9 < 3x$，即 $x > 3$\\n$7 - 3x > 1$ 得 $6 > 3x$，即 $x < 2$\\n取聯集：$x < 2$ 或 $x > 3$",
        topic: "不等式",
        difficulty: "基礎"
      },
      {
        id: "2017Q006",
        questionNumber: 6,
        question: "設 $k$ 為一常數。若 $f(x) = 2x^2 - 5x + k$，則 $f(2) - f(-2) =$",
        options: [
          { id: "A", text: "$-20$" },
          { id: "B", text: "$0$" },
          { id: "C", text: "$16$" },
          { id: "D", text: "$2k$" }
        ],
        correctAnswer: "C",
        solution: "$f(2) = 2(2)^2 - 5(2) + k = 8 - 10 + k = -2 + k$\\n$f(-2) = 2(-2)^2 - 5(-2) + k = 8 + 10 + k = 18 + k$\\n$f(2) - f(-2) = (-2 + k) - (18 + k) = -20$",
        topic: "函數",
        difficulty: "基礎"
      },
      {
        id: "2017Q007",
        questionNumber: 7,
        question: "設 $p(x) = 2x^2 - 11x + c$，其中 $c$ 為一常數。若 $p(x)$ 可被 $x - 7$ 整除，求當 $p(x)$ 除以 $2x + 1$ 時的餘數。",
        options: [
          { id: "A", text: "$-26$" },
          { id: "B", text: "$-15$" },
          { id: "C", text: "$15$" },
          { id: "D", text: "$26$" }
        ],
        correctAnswer: "A",
        solution: "$p(7) = 0$（因可被 $x-7$ 整除）\\n$2(7)^2 - 11(7) + c = 0$\\n$98 - 77 + c = 0$\\n$c = -21$\\n$p(-\\frac{1}{2}) = 2(-\\frac{1}{2})^2 - 11(-\\frac{1}{2}) - 21 = \\frac{1}{2} + \\frac{11}{2} - 21 = -15$",
        topic: "多項式",
        difficulty: "中等"
      },
      {
        id: "2017Q008",
        questionNumber: 8,
        question: "若 $m$ 及 $n$ 均為常數使得 $4x^2 + m(x+1) + 28 = mx(x+3) + n(x-4)$，則 $n =$",
        options: [
          { id: "A", text: "$-8$" },
          { id: "B", text: "$-7$" },
          { id: "C", text: "$4$" },
          { id: "D", text: "$16$" }
        ],
        correctAnswer: "C",
        solution: "$4x^2 + m(x+1) + 28 = mx(x+3) + n(x-4)$\\n$4x^2 + mx + m + 28 = mx^2 + 3mx + nx - 4n$\\n比較係數：$4 = m$，$m = 3m + n$，$m + 28 = -4n$\\n$m = 4$，$n = -2m = -8$",
        topic: "恆等式",
        difficulty: "中等"
      },
      {
        id: "2017Q009",
        questionNumber: 9,
        question: "圖中所示為 $y = (px+5)^2 + q$ 的圖像，其中 $p$ 及 $q$ 均為常數。下列何者正確？",
        options: [
          { id: "A", text: "$p < 0$ 及 $q < 0$" },
          { id: "B", text: "$p < 0$ 及 $q > 0$" },
          { id: "C", text: "$p > 0$ 及 $q < 0$" },
          { id: "D", text: "$p > 0$ 及 $q > 0$" }
        ],
        correctAnswer: "C",
        solution: "拋物線開口向上，所以 $p > 0$\\n頂點在 $x$ 軸下方，所以 $q < 0$",
        topic: "二次函數",
        difficulty: "中等"
      },
      {
        id: "2017Q010",
        questionNumber: 10,
        question: "存款 $$2000$，年利率 $5%$，年期 $4$ 年，複利計算，每半年一結。求利息準確至最接近的元。",
        options: [
          { id: "A", text: "$$400$" },
          { id: "B", text: "$$431$" },
          { id: "C", text: "$$437$" },
          { id: "D", text: "$$440$" }
        ],
        correctAnswer: "C",
        solution: "每半年利率 $= \\frac{5%}{2} = 2.5%$\\n期數 $= 4 \\times 2 = 8$\\n本利和 $= 2000 \\times (1.025)^8 \\approx 2437$\\n利息 $= 2437 - 2000 = 437$",
        topic: "複利",
        difficulty: "中等"
      },
      {
        id: "2017Q011",
        questionNumber: 11,
        question: "某地圖的比例尺為 $1:20000$。若某動物園在該地圖上的面積為 $4$ cm$^2$，則該動物園的實際面積為",
        options: [
          { id: "A", text: "$8 \\times 10^4$ m$^2$" },
          { id: "B", text: "$1.6 \\times 10^5$ m$^2$" },
          { id: "C", text: "$3.2 \\times 10^5$ m$^2$" },
          { id: "D", text: "$1 \\times 10^6$ m$^2$" }
        ],
        correctAnswer: "B",
        solution: "面積比例 $= (1:20000)^2 = 1:4 \\times 10^8$\\n實際面積 $= 4 \\times 4 \\times 10^8 = 1.6 \\times 10^9$ cm$^2$\\n$= 1.6 \\times 10^5$ m$^2$",
        topic: "比例",
        difficulty: "中等"
      },
      {
        id: "2017Q012",
        questionNumber: 12,
        question: "已知 $y$ 為兩部分之和，一部分為常數，而另一部分隨 $x^2$ 正變。當 $x = 1$ 時，$y = 7$，且當 $x = 2$ 時，$y = 13$。若 $x = 3$，則 $y =$",
        options: [
          { id: "A", text: "$19$" },
          { id: "B", text: "$20$" },
          { id: "C", text: "$23$" },
          { id: "D", text: "$47$" }
        ],
        correctAnswer: "C",
        solution: "$y = c + kx^2$\\n當 $x = 1$ 時：$7 = c + k$\\n當 $x = 2$ 時：$13 = c + 4k$\\n$6 = 3k$，$k = 2$\\n$c = 5$\\n當 $x = 3$ 時：$y = 5 + 2(9) = 23$",
        topic: "變分",
        difficulty: "中等"
      },
      {
        id: "2017Q013",
        questionNumber: 13,
        question: "圖中，第 $1$ 個圖案包含 $1$ 粒點子。對任意正整數 $n$，第 $(n+1)$ 個圖案是由第 $n$ 個圖案加上 $(2n+2)$ 粒點子所組成。求第 $7$ 個圖案的點子數目。",
        options: [
          { id: "A", text: "$41$" },
          { id: "B", text: "$55$" },
          { id: "C", text: "$71$" },
          { id: "D", text: "$161$" }
        ],
        correctAnswer: "C",
        solution: "第 $n$ 個圖案的點子數目 $= 1 + \\sum_{k=1}^{n-1} (2k+2) = 1 + 2\\sum_{k=1}^{n-1} k + 2(n-1)$\\n$= 1 + 2\\frac{(n-1)n}{2} + 2(n-1) = 1 + n(n-1) + 2(n-1) = n^2 + n - 1$\\n第 $7$ 個圖案：$7^2 + 7 - 1 = 49 + 7 - 1 = 55$",
        topic: "數列",
        difficulty: "中等"
      },
      {
        id: "2017Q014",
        questionNumber: 14,
        question: "圖中，$D$ 為 $AC$ 上的一點使得 $BD$ 垂直於 $AC$。已知 $AC = 14$ cm 及 $BD = 12$ cm。若 $\\triangle ABD$ 的面積較 $\\triangle BCD$ 的面積大 $24$ cm$^2$，則 $\\triangle ABC$ 的周界為",
        options: [
          { id: "A", text: "$30$ cm" },
          { id: "B", text: "$42$ cm" },
          { id: "C", text: "$54$ cm" },
          { id: "D", text: "$84$ cm" }
        ],
        correctAnswer: "B",
        solution: "設 $AD = x$，則 $DC = 14 - x$\\n$\\triangle ABD$ 的面積 $= \\frac{1}{2} \\times x \\times 12 = 6x$\\n$\\triangle BCD$ 的面積 $= \\frac{1}{2} \\times (14-x) \\times 12 = 6(14-x)$\\n$6x - 6(14-x) = 24$\\n$6x - 84 + 6x = 24$\\n$12x = 108$\\n$x = 9$\\n$AD = 9$，$DC = 5$\\n$AB = \\sqrt{9^2 + 12^2} = 15$\\n$BC = \\sqrt{5^2 + 12^2} = 13$\\n周界 $= 15 + 13 + 14 = 42$",
        topic: "面積",
        difficulty: "中等"
      },
      {
        id: "2017Q015",
        questionNumber: 15,
        question: "一直立圓錐體的底半徑為一直立圓柱體的底半徑的 $2$ 倍，而該圓柱體的高為該圓錐體的高的 $3$ 倍。若該圓錐體的體積為 $36\\pi$ cm$^3$，則該圓柱體的體積為",
        options: [
          { id: "A", text: "$27\\pi$ cm$^3$" },
          { id: "B", text: "$48\\pi$ cm$^3$" },
          { id: "C", text: "$81\\pi$ cm$^3$" },
          { id: "D", text: "$144\\pi$ cm$^3$" }
        ],
        correctAnswer: "C",
        solution: "設圓錐體的底半徑為 $r$，高為 $h$\\n圓柱體的底半徑為 $\\frac{r}{2}$，高為 $3h$\\n圓錐體體積 $= \\frac{1}{3}\\pi r^2 h = 36\\pi$\\n$r^2 h = 108$\\n圓柱體體積 $= \\pi(\\frac{r}{2})^2(3h) = \\pi \\frac{r^2}{4}(3h) = \\frac{3}{4}\\pi r^2 h = \\frac{3}{4}(108)\\pi = 81\\pi$",
        topic: "立體幾何",
        difficulty: "中等"
      },
      {
        id: "2017Q016",
        questionNumber: 16,
        question: "圖中，$ABCD$ 及 $BEDF$ 均為平行四邊形。$E$ 為 $BC$ 上的一點使得 $BE : EC = 2 : 3$。$AC$ 分別與 $BF$ 及 $DE$ 相交於 $G$ 及 $H$。若 $\\triangle ABG$ 的面積為 $135$ cm$^2$，則四邊形 $DFGH$ 的面積為",
        options: [
          { id: "A", text: "$60$ cm$^2$" },
          { id: "B", text: "$81$ cm$^2$" },
          { id: "C", text: "$90$ cm$^2$" },
          { id: "D", text: "$144$ cm$^2$" }
        ],
        correctAnswer: "A",
        solution: "$BE : EC = 2 : 3$\\n$\\triangle ABG$ 與 $\\triangle DFH$ 相似\\n面積比 $= (\\frac{BE}{EC})^2 = (\\frac{2}{3})^2 = \\frac{4}{9}$\\n$\\triangle ABG$ 的面積 $= 135$\\n$\\triangle DFH$ 的面積 $= 135 \\times \\frac{4}{9} = 60$",
        topic: "相似三角形",
        difficulty: "困難"
      },
      {
        id: "2017Q017",
        questionNumber: 17,
        question: "圖中，$ABC$ 為一等邊三角形，其邊長為 $16$ cm。$D$ 及 $E$ 分別為 $AB$ 及 $BC$ 上的點使得 $AD = 4$ cm 及 $\\angle CDE = 60°$。求 $CE$。",
        options: [
          { id: "A", text: "$9$ cm" },
          { id: "B", text: "$10$ cm" },
          { id: "C", text: "$12$ cm" },
          { id: "D", text: "$13$ cm" }
        ],
        correctAnswer: "C",
        solution: "$AD = 4$ cm，所以 $DB = 12$ cm\\n$\\angle CDE = 60°$\\n$\\triangle CDE$ 為等邊三角形\\n$CE = CD = 12$ cm",
        topic: "幾何",
        difficulty: "中等"
      },
      {
        id: "2017Q018",
        questionNumber: 18,
        question: "圖中，$AB = BC$ 及 $D$ 為 $AE$ 上的一點使得 $AC = AD$。若 $AE // BC$，則 $\\angle ABC =$",
        options: [
          { id: "A", text: "$44°$" },
          { id: "B", text: "$56°$" },
          { id: "C", text: "$62°$" },
          { id: "D", text: "$68°$" }
        ],
        correctAnswer: "B",
        solution: "$AB = BC$，所以 $\\triangle ABC$ 為等腰三角形\\n$AE // BC$，所以 $\\angle BAE = \\angle ABC$\\n$AC = AD$，所以 $\\angle ACD = \\angle ADC$\\n$\\angle ABC = 56°$",
        topic: "角度",
        difficulty: "中等"
      },
      {
        id: "2017Q019",
        questionNumber: 19,
        question: "圖中，連接 $A$ 與 $H$ 的線段的長度為",
        options: [
          { id: "A", text: "$6$" },
          { id: "B", text: "$8$" },
          { id: "C", text: "$9$" },
          { id: "D", text: "$10$" }
        ],
        correctAnswer: "D",
        solution: "從圖像讀取坐標\\n$A$ 的坐標為 $(0, 0)$\\n$H$ 的坐標為 $(6, 8)$\\n距離 $= \\sqrt{6^2 + 8^2} = \\sqrt{36 + 64} = \\sqrt{100} = 10$",
        topic: "坐標幾何",
        difficulty: "基礎"
      },
      {
        id: "2017Q020",
        questionNumber: 20,
        question: "$ABCD$ 為一平行四邊形。設 $E$ 為 $AD$ 的中點。若 $\\angle ABE = \\angle CBD = \\angle DBE$，則下列何者正確？\\nI. $AB = BD$\\nII. $\\angle ABC = 135°$\\nIII. $\\triangle ABE \\cong \\triangle DBE$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "D",
        solution: "$\\angle ABE = \\angle CBD = \\angle DBE$\\n$\\angle ABC = \\angle ABE + \\angle DBE = 2\\angle ABE$\\n$\\angle ABC = 135°$\\n$AB = BD$（等腰三角形）\\n$\\triangle ABE \\cong \\triangle DBE$（SAS）",
        topic: "平行四邊形",
        difficulty: "困難"
      },
      {
        id: "2017Q021",
        questionNumber: 21,
        question: "圖中，$AD$ 為圓 $ABCDE$ 的一直徑。若 $BC = CD$ 及 $\\angle ABC = 110°$，則 $\\angle BED =$",
        options: [
          { id: "A", text: "$20°$" },
          { id: "B", text: "$35°$" },
          { id: "C", text: "$40°$" },
          { id: "D", text: "$55°$" }
        ],
        correctAnswer: "B",
        solution: "$\\angle ABC = 110°$\\n$BC = CD$，所以 $\\angle BDC = \\angle CBD = 35°$\\n$\\angle BED = 180° - 110° - 35° = 35°$",
        topic: "圓",
        difficulty: "中等"
      },
      {
        id: "2017Q022",
        questionNumber: 22,
        question: "圖中，$ABCD$ 為一長方形。若 $E$ 為 $CD$ 上的一點使得 $\\angle CBE = 40°$，求 $\\angle AED$ 準確至最接近的度。",
        options: [
          { id: "A", text: "$33°$" },
          { id: "B", text: "$43°$" },
          { id: "C", text: "$47°$" },
          { id: "D", text: "$57°$" }
        ],
        correctAnswer: "C",
        solution: "$\\angle CBE = 40°$\\n$\\angle ABE = 90° - 40° = 50°$\\n$\\angle AED = 180° - 50° - 83° = 47°$",
        topic: "角度",
        difficulty: "中等"
      },
      {
        id: "2017Q023",
        questionNumber: 23,
        question: "圖中，直線 $L_1$ 及直線 $L_2$ 的方程分別為 $x + my = n$ 及 $x + py = q$。下列何者正確？\\nI. $m < p$\\nII. $n > q$\\nIII. $n + m < p + q$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "B",
        solution: "從圖像讀取：$L_1$ 的斜率 $= -\\frac{1}{m}$\\n$L_2$ 的斜率 $= -\\frac{1}{p}$\\n$L_1$ 較陡，所以 $m < p$\\n交點在 $y$ 軸下方，所以 $n > q$",
        topic: "直線方程",
        difficulty: "中等"
      },
      {
        id: "2017Q024",
        questionNumber: 24,
        question: "直線 $L$ 垂直於直線 $9x - 5y + 45 = 0$。若 $L$ 的 $x$ 截距為 $-3$，則 $L$ 的方程為",
        options: [
          { id: "A", text: "$5x + 9y + 15 = 0$" },
          { id: "B", text: "$5x + 9y + 27 = 0$" },
          { id: "C", text: "$9x - 5y + 15 = 0$" },
          { id: "D", text: "$9x - 5y + 27 = 0$" }
        ],
        correctAnswer: "A",
        solution: "原直線的斜率 $= \\frac{9}{5}$\\n$L$ 的斜率 $= -\\frac{5}{9}$\\n$L$ 通過點 $(-3, 0)$\\n$y = -\\frac{5}{9}(x+3)$\\n$9y = -5x - 15$\\n$5x + 9y + 15 = 0$",
        topic: "直線方程",
        difficulty: "中等"
      },
      {
        id: "2017Q025",
        questionNumber: 25,
        question: "點 $P$、點 $Q$ 及點 $R$ 的極坐標分別為 $(3, 160°)$、$(4, 280°)$ 及 $(6, 340°)$。由 $Q$ 至 $PR$ 的垂直距離為",
        options: [
          { id: "A", text: "$2$" },
          { id: "B", text: "$3$" },
          { id: "C", text: "$2\\sqrt{3}$" },
          { id: "D", text: "$3\\sqrt{3}$" }
        ],
        correctAnswer: "A",
        solution: "轉換為直角坐標：\\n$P(3\\cos 160°, 3\\sin 160°)$\\n$Q(4\\cos 280°, 4\\sin 280°)$\\n$R(6\\cos 340°, 6\\sin 340°)$\\n計算 $Q$ 至 $PR$ 的垂直距離 $= 2$",
        topic: "極坐標",
        difficulty: "困難"
      },
      {
        id: "2017Q026",
        questionNumber: 26,
        question: "圓 $C_1$ 及圓 $C_2$ 的方程分別為 $x^2 + y^2 + 8x - 4y - 5 = 0$ 及 $2x^2 + 2y^2 + 8x - 4y - 5 = 0$。設 $G_1$ 及 $G_2$ 分別為 $C_1$ 及 $C_2$ 的圓心。將原點記為 $O$。下列何者正確？\\nI. $G_1$、$G_2$ 與 $O$ 共線。\\nII. $C_1$ 與 $C_2$ 的半徑相等。\\nIII. $O$ 與 $G_1$ 及 $G_2$ 等距。",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "C",
        solution: "$C_1$：$(x+4)^2 + (y-2)^2 = 25$，圓心 $(-4, 2)$，半徑 $5$\\n$C_2$：$(x+2)^2 + (y-1)^2 = \\frac{25}{2}$，圓心 $(-2, 1)$，半徑 $\\frac{5\\sqrt{2}}{2}$\\n$G_1$、$G_2$ 與 $O$ 共線\\n$O$ 與 $G_1$ 及 $G_2$ 等距",
        topic: "圓",
        difficulty: "中等"
      },
      {
        id: "2017Q027",
        questionNumber: 27,
        question: "已知 $A$ 及 $B$ 為圓 $x^2 + y^2 - 6x - 4y - 87 = 0$ 上的兩相異點。設 $P$ 為直角坐標平面上的一動點使得 $AP = BP$。$P$ 的軌跡的方程為 $x + 2y + k = 0$，其中 $k$ 為一常數。求 $k$。",
        options: [
          { id: "A", text: "$-8$" },
          { id: "B", text: "$-7$" },
          { id: "C", text: "$7$" },
          { id: "D", text: "$8$" }
        ],
        correctAnswer: "A",
        solution: "圓心 $(3, 2)$\\n$P$ 的軌跡為 $AB$ 的垂直平分線\\n垂直平分線通過圓心\\n$3 + 2(2) + k = 0$\\n$k = -7$",
        topic: "軌跡",
        difficulty: "困難"
      },
      {
        id: "2017Q028",
        questionNumber: 28,
        question: "下面的棒形圖顯示某群小童在一遊戲中所獲代幣的數目的分佈。若從該群中隨機選出一名小童，求所選出的小童在該遊戲中獲得少於 $5$ 個代幣的概率。",
        options: [
          { id: "A", text: "$\\frac{2}{3}$" },
          { id: "B", text: "$\\frac{2}{5}$" },
          { id: "C", text: "$\\frac{5}{12}$" },
          { id: "D", text: "$\\frac{7}{25}$" }
        ],
        correctAnswer: "A",
        solution: "少於 $5$ 個代幣的小童數目 $= 5 + 20 = 25$\\n總小童數目 $= 5 + 20 + 15 + 10 + 10 = 60$\\n概率 $= \\frac{25}{60} = \\frac{5}{12}$",
        topic: "概率",
        difficulty: "基礎"
      },
      {
        id: "2017Q029",
        questionNumber: 29,
        question: "下面的框線圖顯示一班學生在某星期的上網時數的分佈。求該分佈的下四分位數。",
        options: [
          { id: "A", text: "$5$" },
          { id: "B", text: "$15$" },
          { id: "C", text: "$25$" },
          { id: "D", text: "$40$" }
        ],
        correctAnswer: "B",
        solution: "從框線圖讀取下四分位數 $= 15$",
        topic: "統計",
        difficulty: "基礎"
      },
      {
        id: "2017Q030",
        questionNumber: 30,
        question: "考慮以下正整數：\\n$2 \\quad 3 \\quad 4 \\quad 6 \\quad 7 \\quad 9 \\quad 10 \\quad m \\quad n$\\n設 $a$、$b$ 及 $c$ 分別為以上正整數的眾數、中位數及分佈域。若以上正整數的平均值為 $5$，則下列何者必為正確？\\nI. $a = 2$\\nII. $b = 4$\\nIII. $c = 8$",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "D",
        solution: "平均值 $= 5$\\n$\\frac{2+3+4+6+7+9+10+m+n}{9} = 5$\\n$41 + m + n = 45$\\n$m + n = 4$\\n$m = n = 2$（因為都是正整數）\\n眾數 $= 2$，中位數 $= 4$，分佈域 $= 10 - 2 = 8$",
        topic: "統計",
        difficulty: "中等"
      },
      {
        id: "2017Q031",
        questionNumber: 31,
        question: "上圖所示為 $y = f(x)$ 的圖像。若 $g(x) = f\\left(\\frac{x}{2}\\right)$，則下列何者可表示 $y = g(x)$ 的圖像？",
        options: [
          { id: "A", text: "圖像 A" },
          { id: "B", text: "圖像 B" },
          { id: "C", text: "圖像 C" },
          { id: "D", text: "圖像 D" }
        ],
        correctAnswer: "A",
        solution: "$g(x) = f\\left(\\frac{x}{2}\\right)$ 表示水平拉伸 $2$ 倍\\n頂點從 $(0, 10)$ 變為 $(0, 10)$\\n$x$ 截距從 $(-12, 0)$ 和 $(4, 0)$ 變為 $(-24, 0)$ 和 $(8, 0)$",
        topic: "函數變換",
        difficulty: "中等"
      },
      {
        id: "2017Q032",
        questionNumber: 32,
        question: "$8^3 + 8^{19} =$",
        options: [
          { id: "A", text: "$1000000000010_{16}$" },
          { id: "B", text: "$2000000000020_{16}$" },
          { id: "C", text: "$1000000000100_{16}$" },
          { id: "D", text: "$2000000000200_{16}$" }
        ],
        correctAnswer: "A",
        solution: "$8^3 = 512 = 200_{16}$\\n$8^{19} = (2^3)^{19} = 2^{57}$\\n$8^3 + 8^{19} = 200_{16} + 1000000000000_{16} = 1000000000010_{16}$",
        topic: "十六進制",
        difficulty: "困難"
      },
      {
        id: "2017Q033",
        questionNumber: 33,
        question: "圖中的圖像顯示 $x$ 與 $\\sqrt{y}$ 之間的線性關係。下列何者必為正確？",
        options: [
          { id: "A", text: "$y = x^2 - 4x + 8$" },
          { id: "B", text: "$y = x^2 + 4x + 8$" },
          { id: "C", text: "$y = 4x^2 - 32x + 64$" },
          { id: "D", text: "$y = 4x^2 + 32x + 64$" }
        ],
        correctAnswer: "C",
        solution: "$\\sqrt{y} = mx + c$\\n從圖像讀取：$\\sqrt{y} = -2x + 8$\\n$y = (-2x + 8)^2 = 4x^2 - 32x + 64$",
        topic: "函數",
        difficulty: "中等"
      },
      {
        id: "2017Q034",
        questionNumber: 34,
        question: "若 $\\begin{cases} \\log_9 y = x - 3 \\\\ 2(\\log_9 y)^2 = 4 - x \\end{cases}$，則 $y =$",
        options: [
          { id: "A", text: "$-1$ 或 $\\frac{1}{2}$" },
          { id: "B", text: "$1$ 或 $\\frac{1}{3}$" },
          { id: "C", text: "$2$ 或 $\\frac{7}{2}$" },
          { id: "D", text: "$3$ 或 $\\frac{1}{9}$" }
        ],
        correctAnswer: "D",
        solution: "設 $\\log_9 y = t$\\n$t = x - 3$\\n$2t^2 = 4 - x$\\n$2t^2 = 4 - (t + 3)$\\n$2t^2 = 1 - t$\\n$2t^2 + t - 1 = 0$\\n$(2t - 1)(t + 1) = 0$\\n$t = \\frac{1}{2}$ 或 $t = -1$\\n$y = 9^{\\frac{1}{2}} = 3$ 或 $y = 9^{-1} = \\frac{1}{9}$",
        topic: "對數方程",
        difficulty: "困難"
      },
      {
        id: "2017Q035",
        questionNumber: 35,
        question: "若 $k$ 及 $\\frac{5}{2-i} + ki$ 均為實數，則 $k =$",
        options: [
          { id: "A", text: "$-2$" },
          { id: "B", text: "$-1$" },
          { id: "C", text: "$1$" },
          { id: "D", text: "$2$" }
        ],
        correctAnswer: "A",
        solution: "$\\frac{5}{2-i} = \\frac{5(2+i)}{(2-i)(2+i)} = \\frac{10+5i}{5} = 2 + i$\\n$\\frac{5}{2-i} + ki = 2 + i + ki = 2 + (1+k)i$\\n若為實數，則 $1 + k = 0$\\n$k = -1$",
        topic: "複數",
        difficulty: "中等"
      },
      {
        id: "2017Q036",
        questionNumber: 36,
        question: "下列何者為等差數列？\\nI. $\\pi^{30}, \\pi^{45}, \\pi^{60}$\\nII. $30\\pi, 45\\pi, 60\\pi$\\nIII. $\\pi - 30, \\pi - 45, \\pi - 60$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "C",
        solution: "I. $\\pi^{45} - \\pi^{30} \\neq \\pi^{60} - \\pi^{45}$（不是等差）\\nII. $45\\pi - 30\\pi = 15\\pi = 60\\pi - 45\\pi$（是等差）\\nIII. $(\\pi-45) - (\\pi-30) = -15 = (\\pi-60) - (\\pi-45)$（是等差）",
        topic: "數列",
        difficulty: "中等"
      },
      {
        id: "2017Q037",
        questionNumber: 37,
        question: "考慮以下的不等式組：\\n$\\begin{cases} y \\leq 9 \\\\ x - y - 9 \\leq 0 \\\\ x + y - 9 \\geq 0 \\end{cases}$\\n設 $R$ 為表示以上的不等式組的解之區域。若 $(x, y)$ 為 $R$ 中的一點，則 $x - 2y + 43$ 的最大值為",
        options: [
          { id: "A", text: "$25$" },
          { id: "B", text: "$43$" },
          { id: "C", text: "$52$" },
          { id: "D", text: "$61$" }
        ],
        correctAnswer: "D",
        solution: "可行區域的頂點：$(0, 0)$、$(9, 0)$、$(9, 9)$、$(0, 9)$\\n目標函數 $f(x,y) = x - 2y + 43$\\n$f(0,0) = 43$\\n$f(9,0) = 52$\\n$f(9,9) = 34$\\n$f(0,9) = 25$\\n最大值 $= 52$",
        topic: "線性規劃",
        difficulty: "困難"
      },
      {
        id: "2017Q038",
        questionNumber: 38,
        question: "圖中，$ABCD$ 為一長方形。若 $E$ 為 $AC$ 上的一點使得 $AE = 30$ cm，則 $DE =$",
        options: [
          { id: "A", text: "$3\\sqrt{65}$ cm" },
          { id: "B", text: "$5\\sqrt{29}$ cm" },
          { id: "C", text: "$\\sqrt{641}$ cm" },
          { id: "D", text: "$\\sqrt{697}$ cm" }
        ],
        correctAnswer: "A",
        solution: "長方形邊長：$AB = 28$ cm，$BC = 21$ cm\\n$AC = \\sqrt{28^2 + 21^2} = 35$ cm\\n$EC = 35 - 30 = 5$ cm\\n$DE = \\sqrt{5^2 + 21^2} = \\sqrt{25 + 441} = \\sqrt{466} = \\sqrt{2 \\times 233}$",
        topic: "長度",
        difficulty: "中等"
      },
      {
        id: "2017Q039",
        questionNumber: 39,
        question: "圖中，$AD$ 為立於水平地面 $BCD$ 上的鉛垂柱。若 $AB = 25$ m、$AD = 15$ m、$BC = 29$ m 及 $CD = 21$ m，求 $AB$ 與平面 $ACD$ 間的交角準確至最接近的度。",
        options: [
          { id: "A", text: "$53°$" },
          { id: "B", text: "$54°$" },
          { id: "C", text: "$69°$" },
          { id: "D", text: "$70°$" }
        ],
        correctAnswer: "A",
        solution: "設 $AB$ 與平面 $ACD$ 的交角為 $\\theta$\\n$\\sin \\theta = \\frac{AD}{AB} = \\frac{15}{25} = \\frac{3}{5}$\\n$\\theta = \\arcsin \\frac{3}{5} \\approx 53°$",
        topic: "立體幾何",
        difficulty: "困難"
      },
      {
        id: "2017Q040",
        questionNumber: 40,
        question: "圖中，$O$ 為圓 $ABC$ 的圓心。$DE$ 為圓在 $A$ 的切線。若 $\\angle BAD = 68°$ 及 $\\angle BCO = 26°$，則 $\\angle ABC =$",
        options: [
          { id: "A", text: "$42°$" },
          { id: "B", text: "$48°$" },
          { id: "C", text: "$54°$" },
          { id: "D", text: "$64°$" }
        ],
        correctAnswer: "A",
        solution: "$\\angle BAD = 68°$\\n$\\angle BCO = 26°$\\n$\\angle ABC = 180° - 68° - 26° = 86°$\\n但這是圓周角，所以 $\\angle ABC = \\frac{86°}{2} = 43°$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2017Q041",
        questionNumber: 41,
        question: "設 $O$ 為原點。點 $P$ 及點 $Q$ 的坐標分別為 $(p, 0)$ 及 $(0, q)$，其中 $p$ 及 $q$ 均為正數。若 $\\triangle OPQ$ 的內心在直線 $3x + 4y = 3p$ 上，則 $p : q =$",
        options: [
          { id: "A", text: "$2 : 3$" },
          { id: "B", text: "$4 : 3$" },
          { id: "C", text: "$4 : 9$" },
          { id: "D", text: "$7 : 24$" }
        ],
        correctAnswer: "A",
        solution: "內心坐標 $= (\\frac{p}{2}, \\frac{q}{2})$\\n內心在直線 $3x + 4y = 3p$ 上\\n$3(\\frac{p}{2}) + 4(\\frac{q}{2}) = 3p$\\n$\\frac{3p}{2} + 2q = 3p$\\n$2q = \\frac{3p}{2}$\\n$q = \\frac{3p}{4}$\\n$p : q = 4 : 3$",
        topic: "內心",
        difficulty: "困難"
      },
      {
        id: "2017Q042",
        questionNumber: 42,
        question: "某委員會有 $13$ 名學生及 $6$ 名教師。若從該委員會中選出 $5$ 名學生及 $4$ 名教師組成一隊，則可組成多少不同的隊？",
        options: [
          { id: "A", text: "$4290$" },
          { id: "B", text: "$19305$" },
          { id: "C", text: "$92378$" },
          { id: "D", text: "$55598400$" }
        ],
        correctAnswer: "A",
        solution: "選 $5$ 名學生：$C_5^{13} = 1287$\\n選 $4$ 名教師：$C_4^6 = 15$\\n總數 $= 1287 \\times 15 = 19305$",
        topic: "排列組合",
        difficulty: "中等"
      },
      {
        id: "2017Q043",
        questionNumber: 43,
        question: "當佩怡擲一飛鏢時，她擲中目標的概率為 $0.7$。若佩怡擲該飛鏢 $4$ 次，求她擲中目標至多 $3$ 次的概率。",
        options: [
          { id: "A", text: "$0.0081$" },
          { id: "B", text: "$0.2401$" },
          { id: "C", text: "$0.7599$" },
          { id: "D", text: "$0.9919$" }
        ],
        correctAnswer: "C",
        solution: "至多 $3$ 次 $= 1 - P(4 \\text{ 次全中})$\\n$= 1 - (0.7)^4 = 1 - 0.2401 = 0.7599$",
        topic: "概率",
        difficulty: "中等"
      },
      {
        id: "2017Q044",
        questionNumber: 44,
        question: "志誠在某數學考試的標準分為 $-2$。若志誠在該數學考試的得分為 $33$ 分且該數學考試的得分的平均值為 $45$ 分，則該數學考試的得分的標準差為",
        options: [
          { id: "A", text: "$3$ 分" },
          { id: "B", text: "$6$ 分" },
          { id: "C", text: "$12$ 分" },
          { id: "D", text: "$36$ 分" }
        ],
        correctAnswer: "B",
        solution: "標準分 $= \\frac{x - \\mu}{\\sigma} = -2$\\n$\\frac{33 - 45}{\\sigma} = -2$\\n$\\frac{-12}{\\sigma} = -2$\\n$\\sigma = 6$",
        topic: "標準分",
        difficulty: "中等"
      },
      {
        id: "2017Q045",
        questionNumber: 45,
        question: "設 $m_1$、$r_1$ 及 $v_1$ 分別為某組數 $\\{x_1, x_2, x_3, x_4, x_5, x_6, x_7\\}$ 的眾數、四分位數間距及方差，而 $m_2$、$r_2$ 及 $v_2$ 分別為 $\\{8x_1, 8x_2, 8x_3, 8x_4, 8x_5, 8x_6, 8x_7\\}$ 這組數的眾數、四分位數間距及方差。下列何者必為正確？\\nI. $m_2 = 8m_1$\\nII. $r_2 = 8r_1$\\nIII. $v_2 = 8v_1$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "C",
        solution: "新數據 $= 8x$\\n$m_2 = 8m_1$（眾數乘以常數）\\n$r_2 = 8r_1$（四分位數間距乘以常數）\\n$v_2 = 8^2 v_1 = 64v_1$（方差乘以常數的平方）",
        topic: "統計",
        difficulty: "中等"
      }
    ],
    topics: [
      "指數",
      "因式分解",
      "恆等式",
      "二次方程",
      "二次函數", 
      "不等式",
      "函數",
      "對數",
      "三角函數",
      "三角方程",
      "立體幾何",
      "圓",
      "圓與直線",
      "排列組合",
      "統計"
    ],
    statistics: {
      totalAttempts: 0,
      correctAttempts: 0,
      averageScore: 0,
      completionRate: 0
    }
  };